import angular from "angular";

import OrganisationOwnerOrganisationsRouting from './organisation-owner-organisations.module.routing';

export default angular.module("vt-organisation-owner-organisations.module", [])
  .config(OrganisationOwnerOrganisationsRouting);
